export default Object.freeze({
  remember: true,
  company: '',
  user: '',
  password: '',
});
